import React from "react";
import {Route, Routes} from "react-router-dom";
import {DashboardLayout} from "./DashboardLayout";
import {DashboardPage} from "../pages/dashboard/dashboardPage";
import {MemberPage} from "../pages/members/memberPage";
import {MemberView} from "../pages/members/memberView";
import {MemberNew} from "../pages/members/memberNew";
import {NotificationPage} from "../pages/notifications/notificationPage";
import AuditLogPage from "../pages/auditLog/AuditLogPage";
import {StatementPage} from "../pages/statement/statementPage";
import StatementGeneration from "../pages/statement/StatementGeneration";
import StatementGenerationPreview from "../pages/statement/StatementGenerationPreview";
import {UsersPage} from "../pages/userManagement/usersPage";
import {ProfilePage} from "../pages/profile/ProfilePage";
import ScheduleMonth from "../pages/dashboard/schedule/ScheduleMonth";
import { AddCompanyPage } from "../pages/company/AddCompanyPage";
import { MemberRequestPage } from "../pages/memberRequest/MemberRequestPage";
import { ContributionRatesPage } from "../pages/contributionRates/ContributionRatesPage";
import { useProfiles } from "../hooks/api/useProfile";

const GCBEmployerRoute = ({ children }) => {
  const { data: profiles } = useProfiles();
  const activeProfile = profiles?.find((p) => p?.active) || profiles?.[0];
  const isGCB = activeProfile?.employerNumber === 'GCBT2/2024/0225';
  
  if (!isGCB) {
    return <DashboardPage />;
  }
  return children;
};

const Tier3Route = ({ children }) => {
  const { data: profiles } = useProfiles();
  const activeProfile = profiles?.find((p) => p?.active) || profiles?.[0];
  const isActiveTier3 = String(activeProfile?.tier) === "3";
  
  if (!isActiveTier3) {
    return <DashboardPage />;
  }
  return children;
};

export const AuthenticatedRoutes = () => {
    return (
        <DashboardLayout>
            <Routes>
                {/* Define routes for authenticated users */}
                <Route path="/" element={<DashboardPage />} />
                <Route path="/schedule/upload" element={<ScheduleMonth />} />
                <Route path="/members" element={<MemberPage />} />
                <Route path="/members/single" element={<MemberView />} />
                <Route path="/members/new" element={<MemberNew />} />
                <Route path="/notifications" element={<NotificationPage />} />
                <Route path="/audit-logs" element={<AuditLogPage />} />

                {/*===== Statement Generation ======*/}
                <Route path="/statements" element={<StatementPage />} />
                <Route path="/statements/generation" element={<StatementGeneration />} />
                <Route path="/statements/generation/preview" element={<StatementGenerationPreview />} />
                {/*===== End of Statement Generation ======*/}

                <Route path="/member-request" element={<GCBEmployerRoute><MemberRequestPage /></GCBEmployerRoute>} />
                <Route path="/contribution-rates" element={<Tier3Route><ContributionRatesPage /></Tier3Route>} />
                <Route path="/user-management" element={<UsersPage />} />
                <Route path="/profile" element={<ProfilePage />} />
<Route path="/add-company" element={<AddCompanyPage />} />
            </Routes>
        </DashboardLayout>
    )
} 
